import { Box, Button, Divider, Link, Tooltip, Typography, useMediaQuery } from "@mui/material"

import CredzLogoImg from './assets/formaspagamentos/credz.png'
import EloLogoImg from './assets/formaspagamentos/elo.png'
import HipercardLogoImg from './assets/formaspagamentos/hipercard.png'
import AmexLogoImg from './assets/formaspagamentos/amex.png'
import DinersClubLogoImg from './assets/formaspagamentos/dinersclub.png'
import JcbLogoImg from './assets/formaspagamentos/jcb.png'
import MasterLogoImg from './assets/formaspagamentos/mastercard.png'
import VisaLogoImg from './assets/formaspagamentos/visa.png'
import BvLogoImg from './assets/formaspagamentos/bv-financeira.png'
import SantanderLogoImg from './assets/formaspagamentos/santander.png'
import BoletoImg from './assets/formaspagamentos/boleto.png'
import { formState$ } from "src/store/vendas/projetos/store"
import { useHistory } from "react-router-dom"
import { Info } from "@mui/icons-material"
import { Projeto } from "../../types"
import { useMemo, useState } from "react"
import theme from "src/theme/light"
import "./styles.css"

interface ImageProps {
  src: string;
  alt: string
}

const FORMAS_PAGAMENTOS = [
  { image: MasterLogoImg, alt: 'mastercard-logo' },
  { image: VisaLogoImg, alt: 'visa-logo' },
  { image: EloLogoImg, alt: 'elo-logo' },
  { image: HipercardLogoImg, alt: 'hipercard-logo' },
  { image: JcbLogoImg, alt: 'jcb-logo' },
  { image: BvLogoImg, alt: 'bv-logo' },
  { image: SantanderLogoImg, alt: 'santander-logo' },
  { image: CredzLogoImg, alt: 'credz-logo' },
  { image: DinersClubLogoImg, alt: 'dinersclub-logo' },
  { image: AmexLogoImg, alt: 'amex-logo' },
  { image: BoletoImg, alt: 'boleto-logo' },
]

const LogoImage = ({ src, alt }: ImageProps) => {
  return <img width='100%' height='auto' src={src} alt={alt}></img>
}

export interface ResumoProjetoRow {
  label: React.ReactNode;
  value: React.ReactNode;
  hide?: boolean
}

interface ResumoProjetoProps {
  resumoProjeto: ResumoProjetoRow[];
  valores: ResumoProjetoRow[];
  simularFuncionamento?: boolean;
  simularFuncionamentoClick?: () => void
  formState: Projeto
}

const ResumoProjeto = ({ formState, resumoProjeto = [], valores = [], simularFuncionamentoClick, simularFuncionamento = true }: ResumoProjetoProps) => {
  const history = useHistory()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [textoTooltipDesabilitarSimulacao, setTextoTooltipDesabilitarSimulacao] = useState<string>('Para habilitar a simulação, preencha os campos Estado e Cidade na etapa inicial.');
  const [infoDesabilitarSimulacao, setInfoDesabilitarSimulacao] = useState<string>('Para habilitar a simulação, preencha os campos Estado e Cidade na etapa inicial.');

  const ocultarSimulacao = String(process.env.REACT_APP_OCULTAR_SIMULAR_FINANCIAMENTO).toUpperCase() === "TRUE" || !simularFuncionamento;
  
  const desabilitarSimulacao = useMemo(()=>{
    const formStateFields: (keyof Projeto)[] = ['resultado_calculos', 'cliente_proposta', 'cidade', 'estado']
    let ret = formStateFields.some(item => !formState[item])
    if (formState?.tipo_faturamento === 'integrador_cliente') {
      setTextoTooltipDesabilitarSimulacao('Não é possível simular financiamentos para o tipo de faturamento selecionado')
      setInfoDesabilitarSimulacao('');
      ret = true;
    } else {
      setTextoTooltipDesabilitarSimulacao('Para habilitar a simulação, preencha os campos Estado e Cidade na etapa inicial.');
      setInfoDesabilitarSimulacao('Para habilitar a simulação, preencha os campos Estado e Cidade na etapa inicial.');
    }
    return ret;
  },[formState])

  return (
    <Box width='100%' display='flex' flexWrap='wrap' className="resumo-projeto">
      { !isMobile && (
        <Box className='L6 X12' display='flex' width='100%' justifyContent='space-between'>
          <Box display='flex' flexDirection={"column"} alignItems='flex-start'>
            <Box mb={2}>
              <Typography color='primary' align='left' variant='h6'><strong>Formas de pagamento:</strong></Typography>
            </Box>

            <Box display='grid' justifyContent='center' alignItems='center' gridTemplateRows={"80px 80px 80px"} gridTemplateColumns={"80px 80px 80px 80px"} gap={2}>
              {FORMAS_PAGAMENTOS.map(pagamento => <LogoImage src={pagamento.image} alt={pagamento.alt} />)}
            </Box>
          </Box>

          <Divider orientation="vertical"></Divider>
        </Box>
      )}
      <div className='L6 X12'>
        <Box px={isMobile ? 0 : 2}>
          <Box mb={2}>
            <Typography color='primary' align='left' variant='h6'><strong>Valores:</strong></Typography>
          </Box>

          {valores.filter(item => !item.hide).map(item => (
            <Box display='flex' width='100%' style={isMobile ? { marginBottom: 10 } : {}}>
              <Box display='flex' width={isMobile ? '50%' : '70%'} alignItems={'flex-start'} flexDirection={"column"}>

                {typeof item.label === 'string' ? (
                  <Typography style={{ display: 'block', textAlign: 'start' }} variant='subtitle1'>{item.label}</Typography>
                ) : (
                  item.label
                )}

              </Box>
              <Box display='flex' alignItems={isMobile ? 'flex-end' : 'flex-start'} width={isMobile ? '50%' : '30%'} flexDirection={"column"} style={isMobile ? { whiteSpace: "normal", wordBreak: "break-word", textAlign: "right" } : {}}>
                <Typography variant='subtitle1'>{item.value}</Typography>
              </Box>
            </Box>
          ))}

          {!ocultarSimulacao && (
            <Box display='flex' width='100%' justifyContent={'flex-end'} mt={isMobile ? 4 : 8} flexDirection="column" alignItems="end" p={isMobile ? 0 : 2} className="btn-simulacao">
              <Tooltip title={desabilitarSimulacao ? textoTooltipDesabilitarSimulacao : ''}>
                <span style={{ width: isMobile ? "100%" : undefined }}>
                  <Button disabled={desabilitarSimulacao} onClick={simularFuncionamentoClick} variant='contained' color='secondary' fullWidth={isMobile}>
                    <strong>Simular Financiamento</strong>
                  </Button>
                </span>
              </Tooltip>
              <Typography
                variant="body2"
                mt={1.5}
                color="textSecondary"
                style={{ width: isMobile ? "100%" : undefined, textAlign: "left", marginTop: 10, fontSize: 12, fontWeight: "bold" }}
              >
                Sem a simulação, o financiamento não {!isMobile && <br/>} será incluído na proposta.
              </Typography>
            </Box>
          )}

          {desabilitarSimulacao && infoDesabilitarSimulacao && <Box mt={4} display='flex' alignItems={'center'} justifyContent={'center'}>
            <Info /> 
            <span style={{marginLeft: 5}}>{infoDesabilitarSimulacao}</span><br/>
          </Box>}
          {desabilitarSimulacao && infoDesabilitarSimulacao && <Link 
            component="button"
            variant="body2"
            color='secondary'
            onClick={() => {
              formState$.next({ ...formState$.value, ...formState })
              history.push('/projetos', { noReset: true })
            }}>
            Voltar para a primeira etapa     
          </Link>}

        </Box>
        <Box mt={isMobile ? 4 : 20} px={isMobile ? 0 : 2}>
          <Box mb={2}>
            <Typography color='primary' align='left' variant='h6'><strong>Resumo do projeto:</strong></Typography>
          </Box>

          {resumoProjeto.filter(item => !item.hide).map((item, index) => (
            <Box display='flex' width='100%'>
              <Box display='flex' width={(isMobile && !index) ? '30%' : '70%'} alignItems={'flex-start'} flexDirection={"column"} textAlign='left'>
                <Typography variant='subtitle1'>{item.label}</Typography>
              </Box>
              <Box display='flex' alignItems={isMobile ? 'flex-end' : 'flex-start'} width={(isMobile && !index) ? '70%' : '30%'} flexDirection={"column"} textAlign='right'>
                <Typography variant='subtitle1'>{item.value}</Typography>
              </Box>
            </Box>
            ))}
        </Box>
      </div>
    </Box>
  );
}

export { ResumoProjeto }
